<template>
  <el-dialog
    :visible="visible"
    title="实际进仓数据"
    destroy-on-close
    width="1000px"
    @close="onClose"
  >
    <el-form
      ref="form"
      label-width="100px"
      label-position="left"
      :show-message="false"
      :model="form"
    >
      <el-row :gutter="8">
        <el-col :span="8">
          <el-form-item
            label="包装号"
            required
            prop="packageNo"
          >
            <el-input
              v-model="form.packageNo"
              disabled
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-button
            type="primary"
            @click="getEstimatedData"
          >填入预报数据</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="包装类型"
            disabled
            prop="packageType"
          >
            <cargo-advance-select
              disabled
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.packageType"
              tag-name="englishName"
              style="width:100%;"
              @parentCallBack="p=>form.packageType=p.value"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="实际进仓时间"
            required
            prop="incomeDate"
          >
            <el-date-picker
              v-model="form.incomeDate"
              type="date"
              clearable
              style="width:100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row
        :gutter="8"
        style="display:flex"
      >
        <el-col :span="15">
          <el-form-item
            required
            label="单箱实际体积"
            class="volume-col"
          >
            <el-col
              :span="4"
              style="margin-left:-4px"
            >
              <el-form-item
                required
                prop="length"
              >
                <el-input
                  v-model="form.length"
                  placeholder="长(CM)"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="1"
              style="text-align:center"
            >x</el-col>
            <el-col :span="4">
              <el-form-item
                required
                prop="width"
              >
                <el-input
                  v-model="form.width"
                  placeholder="宽(CM)"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="1"
              style="text-align:center"
            >x</el-col>
            <el-col :span="4">
              <el-form-item
                required
                prop="height"
              >
                <el-input
                  v-model="form.height"
                  placeholder="高(CM)"
                />
              </el-form-item>
            </el-col>
            <el-col
              :span="1"
              style="text-align:center"
            >=</el-col>
            <el-col :span="4">{{ form.unitCubage }}</el-col>
            <el-col :span="4">CBM</el-col>
          </el-form-item>
          <el-row :gutter="8">
            <el-col :span="20">
              <el-form-item
                label="单箱实际重量"
                required
                prop="unitGrossWeight"
              >
                <el-input v-model="form.unitGrossWeight" />
              </el-form-item>
            </el-col>
            <el-col :span="4">KGS</el-col>
          </el-row>
        </el-col>
        <el-col
          :span="3"
          style="flex-grow:1;display:flex;align-items:center;margin-top:0"
        >
          <el-row :gutter="8">
            <el-col :span="5">x</el-col>
            <el-col :span="14">
              <el-form-item
                label-width="0"
                required
                prop="quantity"
              >
                <el-input
                  v-model="form.quantity"
                  placeholder="箱数"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">=</el-col>
          </el-row>
        </el-col>
        <el-col
          :span="6"
          style="flex-grow:1;display:flex;justify-content:center;margin-top:0;flex-direction:column"
        >
          <el-row style="width:100%">
            <el-col
              :span="7"
              style="font-size:12px"
            >实际总体积</el-col>
            <el-col
              :span="12"
              style="text-align:right"
            >{{ form.cubage }}</el-col>
            <el-col
              :span="5"
              style="text-align:right"
            >CBM</el-col>
          </el-row>
          <el-row style="width:100%">
            <el-col
              :span="7"
              style="font-size:12px"
            >实际总重量</el-col>
            <el-col
              :span="12"
              style="text-align:right"
            >{{ form.grossWeight }}</el-col>
            <el-col
              :span="5"
              style="text-align:right"
            >KGS</el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <div style="display: flex">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :row-data="rowData"
        :column-defs="columnDefs"
        style="width:100%;min-height: 300px"
      />
    </div>
    <el-row
      slot="footer"
      style="margin-top:15px;"
    >
      <el-col
        :span="18"
        :offset="6"
      >
        <el-form>
          <span>
            <el-button @click="onClose">取 消</el-button>
            <el-button
              type="primary"
              @click="onSave"
            >确定</el-button>
          </span>
        </el-form>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { queryWarehousePoPackage } from '@/api/OMS/warehouseIn'
import { income } from '@/api/OMS/warehouseIn'
import { getLoading } from '@/utils/utilBaseElement'
import { formatRoundNumber } from '@/utils/NumberUtils'
import { isPositiveInteger, isPositiveNumber } from '@/utils/validate'
import ColumnNumberDisplayAndInput from '@/components/Cargo/Common/columnNumberDisplayAndInput'
export default {
  name: 'WarehousingFrom',
  components: { cargoAdvanceSelect, 'columnNumberDisplayAndInput': ColumnNumberDisplayAndInput },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    warehouseInDetailUuid: {
      type: String,
      default: () => ''
    },
    packageUuid: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      form: {
        packageNo: '',
        packageType: '',
        cartonQuantity: '',
        width: '',
        height: '',
        length: '',
        unitCubage: 0,
        unitGrossWeight: '',
        quantity: '',
        cubage: 0,
        grossWeight: 0,
        incomeDate: '',
        uuid: ''
      },
      selectTypeNames: TYPE_NAMES,
      rowData: [],
      gridOptions: {
        suppressCellSelection: false,
        columnApi: null,
        context: {
          componentParent: this
        },
        defaultColDef: {
          editable: true
        }
      },
      columnDefs: [
        {
          headerName: '订单号',
          field: 'poNo',
          width: 150,
          editable: false
        },
        {
          headerName: 'SKU编码',
          field: 'itemNo',
          width: 150,
          editable: false
        },
        {
          headerName: '中文品名',
          field: 'chineseCommodity',
          width: 150,
          editable: false
        },
        {
          headerName: '英文品名',
          field: 'englishCommodity',
          width: 150,
          editable: false
        },
        {
          headerName: 'SKU数量(总/库存/实)',
          field: 'actualQuantity',
          width: 150,
          cellRendererFramework: 'columnNumberDisplayAndInput',
          custom: {
            actual: 'quantity',
            inventory: 'inventoryQuantity'
          }
        },
        {
          headerName: '纸箱数(总/库存/实)',
          field: 'actualCartonQuantity',
          width: 150,
          cellRendererFramework: 'columnNumberDisplayAndInput',
          custom: {
            actual: 'cartonQuantity',
            inventory: 'inventoryCartonQuantity'
          }
        }
      ],
      packageInfo: null
    }
  },
  watch: {
    packageUuid(val) {
      if (val) {
        this.loading = getLoading()
        queryWarehousePoPackage({ poPackageUuid: val }).then((res) => {
          const { data } = res
          Object.keys(this.form).forEach((key) => {
            if (key in data.poPackage) {
              this.form[key] = data.poPackage[key]
            }
          })
          this.packageInfo = data
          this.rowData = data.poPackageItemList
          this.loading.close()
        })
      }
    },
    'form.length': {
      handler(val) {
        const { width, height } = this.form
        if (val && this.form.width && this.form.height) {
          this.form.unitCubage = formatRoundNumber((val * width * height) / 1000000, 3)
        } else {
          this.form.unitCubage = 0
        }
      },
      deep: true
    },
    'form.width': {
      handler(val) {
        const { length, height } = this.form
        if (val && this.form.width && this.form.height) {
          this.form.unitCubage = formatRoundNumber((val * length * height) / 1000000, 3)
        } else {
          this.form.unitCubage = 0
        }
      },
      deep: true
    },
    'form.height': {
      handler(val) {
        const { width, length } = this.form
        if (val && this.form.width && this.form.height) {
          this.form.unitCubage = formatRoundNumber((val * width * length) / 1000000, 3)
        } else {
          this.form.unitCubage = 0
        }
      },
      deep: true
    },
    'form.unitGrossWeight': {
      handler(val) {
        const { quantity } = this.form
        if (val && quantity) {
          this.form.grossWeight = formatRoundNumber(quantity * val, 2)
        } else {
          this.form.grossWeight = 0
        }
      },
      deep: true
    },
    'form.quantity': {
      handler(val) {
        const { unitGrossWeight, unitCubage } = this.form
        if (val && unitGrossWeight) {
          this.form.grossWeight = formatRoundNumber(val * unitGrossWeight, 2)
        } else {
          this.form.grossWeight = 0
        }
        if (val && unitCubage) {
          this.form.cubage = formatRoundNumber(val * unitCubage, 3)
        } else {
          this.form.cubage = 0
        }
      },
      deep: true
    },
    'form.unitCubage': {
      handler(val) {
        const { quantity } = this.form
        if (val && quantity) {
          this.form.cubage = formatRoundNumber(quantity * val, 3)
        } else {
          this.form.cubage = 0
        }
      },
      deep: true
    }
  },
  methods: {
    getEstimatedData() {
      const {
        estimatedLength,
        estimatedWidth,
        estimatedHeight,
        estimatedUnitGrossWeight,
        estimatedQuantity,
        estimatedIncomeDate
      } = this.packageInfo.poPackage
      this.form.incomeDate = estimatedIncomeDate
      this.form.width = estimatedWidth
      this.form.height = estimatedHeight
      this.form.length = estimatedLength
      this.form.unitGrossWeight = estimatedUnitGrossWeight
      this.form.quantity = estimatedQuantity
    },
    onSave() {
      const { form } = this
      console.log('popackage', this.packageInfo.poPackage)
      const poPackage = {
        ...this.packageInfo.poPackage,
        ...form
      }
      if (!poPackage.incomeDate) {
        this.$message.warning('实际进仓时间不能为空')
        return
      }
      if (!isPositiveNumber(poPackage.length)) {
        this.$message.warning('长应为大于0的数字')
        return
      }
      if (!isPositiveNumber(poPackage.width)) {
        this.$message.warning('宽应为大于0的数字')
        return
      }
      if (!isPositiveNumber(poPackage.height)) {
        this.$message.warning('高应为大于0的数字')
        return
      }
      if (!isPositiveNumber(poPackage.unitGrossWeight)) {
        this.$message.warning('单箱重量应为大于0的数字')
        return
      }
      if (!isPositiveInteger(poPackage.quantity)) {
        this.$message.warning('箱数应为大于0的整数')
        return
      }
      this.loading = getLoading()
      const data = {
        incomeDate: this.form.incomeDate,
        poPackage,
        warehouseInDetailUuid: this.warehouseInDetailUuid,
        poPackageItem: this.rowData
      }
      income(data)
        .then((res) => {
          this.$message.success('进仓成功')
          this.loading.close()
          this.onClose()
        })
        .catch(() => {
          this.loading.close()
        })
    },
    onClose() {
      this.$emit('onClose')
    },
    onCellChange(data) {
      if (data.actualQuantity > data.inventoryQuantity) {
        data.actualQuantity = data.inventoryQuantity
      }
      if (data.actualCartonQuantity > data.inventoryCartonQuantity) {
        data.actualCartonQuantity = data.inventoryCartonQuantity
      }
    }
  }
}
</script>
<style lang="scss">
#app .app-main-inner-row .el-form .volume-col {
  .el-col {
    margin-top: 0;
  }
}
</style>
